export const blockIconsToggleStarBorder = (
	<span className='material-symbols-outlined'>star_border</span>
);
